<template>
  <thuHoiDialog
    :widthDialog="'450px'"
    :classDialog="'refuse-dialog'"
    :isOpen="isOpen"
    :modalAppendToBody="true"
    :appendToBody="true"
    :dialogTitle="'Từ chối tiếp nhận'"
    :labelFieldForm="'Lý do từ chối'"
    @closeDialog="$emit('closeDialog')"
    @dialogClosed="$emit('dialogClosed')"
    @save="save"
  >
  </thuHoiDialog>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import incomingDocService from "../../../services/incomingDocService";
import { EventBus } from '../../../event-bus.js';

export default {
  name: "tuChoiVanThuDialog",
  mixins: [handleRequestErrorMixin],
  props: ["vbIncomingDocId", "isOpen"],
  components: {
    thuHoiDialog: () => import('../../doc-out/components/thuHoiDialog')
  },
  computed: {

    parentRoute () {
      return this.$route.path.split("/")[3];
    },
  },
  methods: {
    backModel () {
      this.$router.push({ name: this.parentRoute, params: this.$route.params });;
    },

    save (event) {
      incomingDocService
        .tuChoiTiepNhan({ content: event.form.comment }, this.vbIncomingDocId)
        .then(response => {
          this.$message({ message: 'Từ chối chuyển xử lý thành công', type: 'success' });
          this.$emit("success", { vbIncomingDoc: response.data });
          EventBus.$emit(this.parentRoute, {});
          this.backModel();
        })
        .catch((error) => this.commonHandleRequestError(error));
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/tuChoiVanThuDialog.vue